
        Component.define('welcome', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

$('.go-to-content').on('click', function(){
    Navigation.helpers.scrollTo($('section#youshare'));
});

        });